import axios from 'axios'
import { auth } from '@/store/firebase'

const getBaseUrl = () => {
  if (process.env.VUE_APP_API_URL) return process.env.VUE_APP_API_URL

  // Usa a URL atual do browser
  const baseUrl = window.location.origin

  // Se for localhost, usa a URL específica do emulador
  if (baseUrl.includes('localhost')) {
    return 'http://localhost:5000/ultracarebr/southamerica-east1'
  }

  return `${baseUrl}/functions`
}

const api = axios.create({
  baseURL: getBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(async config => {
  try {
    const token = await auth.currentUser.getIdToken()
    if (token) {
      config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`
    }
    return config
  } catch (error) {
    return Promise.reject(error)
  }
})

// Interceptor para tratamento de erros
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // O servidor respondeu com um status de erro
      console.error('Erro na resposta:', error.response.data)
    } else if (error.request) {
      // A requisição foi feita mas não houve resposta
      console.error('Erro na requisição:', error.request)
    } else {
      // Algo aconteceu na configuração da requisição
      console.error('Erro:', error.message)
    }
    return Promise.reject(error)
  }
)

export default api



// WEBPACK FOOTER //
// ./src/utils/api.js